import MerchantConstants from '../../constants/MerchantConstants';
var initialState = {
  address: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zip: ''
  },
  password: '',
  confirm_password: '',
  owner_first_name: '',
  owner_last_name: '',
  email: '',
  background_url: '',
  contact_email: '',
  description: '',
  display_phone: '',
  logo_url: '',
  name: '',
  website: '',
  latitude: '',
  longitude: '',
  visible_to_customers: '',
  merchant_types: [],
  types_id: [],
  types: [],
  enabled: '',
  requires_qr_code: ''
};

export default function profileForm(state = initialState, action) {
  switch (action.type) {
    case MerchantConstants.SET_PROFILE_FORM:
      return action.payload;
    case MerchantConstants.SET_PROFILE_FIELD_ADDRESS:
      return {
        ...state,
        address: {
          ...state.address,
          [action.payload.name]: action.payload.value
        }
      };
    case MerchantConstants.SET_OPEN_HOURS:
      return {
        ...state,
        opening_hours_raw: action.payload
      };
    case MerchantConstants.MERCHANT_SET_ADDRESS:
      let address = action.payload;
      return {
        ...state,
        address: {
          line1: address.line1 ? address.line1 : state.address.line1,
          line2: address.line2 ? address.line2 : state.address.line2,
          city: address.city ? address.city : state.address.city,
          state: address.state ? address.state : state.address.state,
          zip: address.zip ? address.zip : state.address.zip,
        },
        latitude: address.latitude ? address.latitude : state.latitude,
        longitude: address.longitude ? address.longitude : state.longitude,
      };
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/forms/profileForm.js
 **/